const convertRemToPixels = (rem) => {
	return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export function scrollToTarget(target, config = {}) {
	const defaultConfig = {
		instant: false, // bool
		scrollWrapper: document.documentElement, // element
		offset: 0, // number
		duration: 500, // number milliseconds
	}

	config = Object.assign({}, defaultConfig, config);

	const duration = config.instant ? 0 : config.duration;
	const offset = config.offset || 0;

	$(config.scrollWrapper).animate({
        scrollTop: $(target).offset().top + offset,
    }, duration);
}

const headerScrollDown = (header) => {
	header.classList.remove('header--scroll-up');
	header.classList.add('header--scroll-down');
}

const headerScrollUp = (header) => {
	header.classList.remove('header--scroll-down');
	header.classList.add('header--scroll-up');
}

/**
 * Sets up the scrolled class
 */
export function setupScrolling()
{
	let lastScrollTop = 0;

	const body = document.body;
	const header = document.querySelector('.header--fixed');

	window.addEventListener('scroll', () => {
		//Add the 'scrolled' class
		let currentScroll = window.pageYOffset

		currentScroll > lastScrollTop
			? headerScrollDown(header)
			: headerScrollUp(header)

		// For Mobile or negative scrolling
		setTimeout(() => {
			lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
		}, 50)

		body.classList.toggle('scrolled', currentScroll >= window.innerHeight)
	});
}

/**
* Sets up a scroll to top on any back to top classes
*/
export function setupBackToTop()
{
	$('.back-to-top').on('click', function (e){
		e.preventDefault();
		$('html,body').animate({
			scrollTop: 0,
		}, 'slow');
	});
}


export function scrollPastHomeHero()
{
	const darrButton = document.querySelector('.hero-darr');

	const scrollToNextSection = () => {
		const homeHero = document.querySelector('.hero-wrapper--relative');
		const breakpoint = window.matchMedia('(max-width: 980px)')

		if(homeHero) {
			const sibling = homeHero.nextElementSibling
			const header = document.querySelector('.header');
			const { clientHeight } = header;

			let offset = breakpoint.matches ? 0 : clientHeight;

			scrollToTarget(sibling, {
				offset,
			});
		}
	}

	if(darrButton) {
		darrButton.addEventListener('click', scrollToNextSection);
	}
}

// Expects a URL()
function linkIsSamePage(url) {
	const linkLocation = url.origin + url.pathname;
	const windowLocation = window.location.origin + window.location.pathname;

	return linkLocation === windowLocation;
}

function getHashLinks() {
	const allLinks = Array.from(document.querySelectorAll('a[href]'));
	const hashLinks = allLinks.filter(link => {
		const url = new URL(link.href);
		if (url.hash && linkIsSamePage(url)) {
			return true;
		}

		return false;
	});

	return hashLinks;
}

function hashLinkClickDelegate(e) {
	if ('a' === e.target.tagName.toLowerCase() && e.target.dataset.href) {
		const url = new URL(e.target.dataset.href);

		if (url.hash) {
			const hash = url.hash;

			e.preventDefault();
			e.stopPropagation();

			scrollToTarget(hash, {offset: convertRemToPixels(4) });
		}
	}
}

function initHashLinks() {
	const hashLinks = getHashLinks();

	hashLinks.forEach(link => {
		link.dataset.href = link.href;
		link.href = '';
	}, {passive: false});

	window.addEventListener('click', hashLinkClickDelegate, {passive: false});
}

function cleanup_hash_links() {
	window.removeEventListener('click', hashLinkClickDelegate);
}

export function initScrollingFeatures() {
	initHashLinks();
}

export function unload_scrolling_features() {
	cleanup_hash_links();
}



// WEBPACK FOOTER //
// ./scripts/modules/scrolling.js